export default "__VITE_ASSET__Da5AwRj1__"